import { WizardStepTree } from '../../../../wizard/interfaces/wizard-step';
import { CreatePipelineWizardEntitySelectionDisplay } from '../../components/CreatePipelineWizardHeaderStepComponents';
import { CreatePipelineStepGroups } from '../interfaces/create-pipeline-step-paths';

export const CREATE_PIPELINE_STEP_GROUPS: WizardStepTree = {
  for: '',
  title: 'Create Pipeline',
  id: 'create-pipeline',
  children: [
    {
      title: 'Source Configuration',
      for: CreatePipelineStepGroups.SOURCE_SELECTION,
      id: CreatePipelineStepGroups.SOURCE_SELECTION,
      children: [],
      Extra: CreatePipelineWizardEntitySelectionDisplay,
      extraProps: {
        title: 'Selection'
      }
    },
    {
      title: 'Destination Configuration',
      for: CreatePipelineStepGroups.DESTINATION_SELECTION,
      id: CreatePipelineStepGroups.DESTINATION_SELECTION,
      children: [],
      Extra: CreatePipelineWizardEntitySelectionDisplay
    },
    {
      title: 'Pipeline Configuration',
      for: CreatePipelineStepGroups.PIPELINE_CONFIGURATION,
      id: CreatePipelineStepGroups.PIPELINE_CONFIGURATION,
      children: []
    },
    {
      title: 'Object Configuration',
      for: CreatePipelineStepGroups.OBJECT_CONFIGURATION,
      id: CreatePipelineStepGroups.OBJECT_CONFIGURATION,
      children: []
    },
    {
      title: 'Review',
      for: CreatePipelineStepGroups.REVIEW,
      id: CreatePipelineStepGroups.REVIEW,
      children: []
    }
  ]
};
